@if (!hidden()) {
  <div class="inputs" [class.range]="showDateRange()">
    <div>
      @let hasWarning = !hasError() && !!warning();
      <onyx-datepicker-input
        [attr.data-testid]="
          showDateRange() ? 'from-datepicker-input' : 'datepicker-input'
        "
        [label]="label() || !!labelTo()"
        [hint]="hint()"
        [showIndefinite]="showIndefinite() && !showDateRange()"
        [indefiniteLabel]="indefiniteLabel()"
        [disabled]="disabled()"
        [required]="required() && showRequired()"
        [size]="size()"
        [showClear]="showClear()"
        [hasWarning]="hasWarning"
        [showYear]="showYear()"
        [forceError]="isInvalid() || forceError()"
        (valueChange)="changeFromValue($event)"
        (inputClick)="
          openCalendarAndFocus($event, datepickerInputFromComponent)
        "
        (inputFocusout)="focusoutCloseFromCalendar()"
        (keydown.tab)="enableFocusout()"
        (keydown.shift.tab)="enableFocusout()"
        #datepickerInputFromComponent
      ></onyx-datepicker-input>

      @let control = formField() ?? formControl();
      @if (showErrors() && control) {
        <onyx-error
          [errors]="[control]"
          variant="control"
          (hasErrorChange)="hasError.set($event)"
        ></onyx-error>
      }

      @if (hasWarning) {
        <div class="warning">
          <onyx-icon
            name="alert-circle-two-tone-filled"
            [size]="12"
          ></onyx-icon>

          <span class="f-body-xs f-medium">
            {{ warning() | translate }}
          </span>
        </div>
      }
    </div>

    @if (showDateRange()) {
      <div
        class="separator size-{{ size() }}"
        [class.label]="label() || labelTo()"
      >
        -
      </div>

      <onyx-datepicker-input
        [attr.data-testid]="showDateRange() ? 'to-datepicker-input' : null"
        [label]="labelTo() || !!label()"
        [showIndefinite]="showIndefinite()"
        [indefiniteLabel]="indefiniteLabel()"
        [disabled]="disabled()"
        [required]="required() && showRequired()"
        [size]="size()"
        [showClear]="showClear()"
        [hasWarning]="hasWarning"
        [showYear]="showYear()"
        [forceError]="isInvalid() || forceError()"
        (valueChange)="changeToValue($event)"
        (inputClick)="openCalendarAndFocus($event, datepickerInputToComponent)"
        (inputFocusout)="focusoutCloseCalendar()"
        (keydown.tab)="enableFocusout()"
        #datepickerInputToComponent
      ></onyx-datepicker-input>
    }
  </div>
}
